import { gettingStarted } from './privateCloudBusinessEditionFactoryConfigVMware';
export const pagesConfig = [...gettingStarted()];
